import { Leaf } from "lucide-react";

const PILLARS = [
  {
    n: "01",
    title: "Strategy",
    accent: "gold",
    body: "Forward-thinking guidance that equips organizations to unlock their full potential — through tailored strategies and innovative growth frameworks designed for measurable outcomes.",
  },
  {
    n: "02",
    title: "Solutions",
    accent: "green",
    body: "High-impact procurement solutions designed to increase efficiency, reduce costs, and strengthen resource management — without compromising on quality or compliance.",
  },
  {
    n: "03",
    title: "Leadership",
    accent: "gold",
    body: "We help organizations and communities build scalable, sustainable frameworks through strategic planning, governance, and long-term growth solutions led with disciplined excellence.",
  },
  {
    n: "04",
    title: "Growth",
    accent: "green",
    body: "Workforce development and community programs powered by targeted outreach, advocacy, and economic initiatives — creating meaningful, lasting change for the organizations we serve.",
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="bg-[#0A0A0A] py-24 md:py-32 lg:py-40 border-t border-[#2A2A2A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4 reveal">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#C9A66B] mb-4 flex items-center gap-2">
              <Leaf size={14} className="text-[#6B6B6B]" />
              Four Pillars
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#EDEDED]">
              The architecture <br />
              of <em className="text-[#6B6B6B]">excellence</em>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6 reveal">
            <p className="text-base md:text-lg text-[#A0A0A0] font-light leading-relaxed">
              Becoming H.E.R. LLC is a premier consulting and professional
              support services firm. Our four pillars — Strategy, Solutions,
              Leadership, and Growth — define how we partner with organizations
              and communities to build stronger foundations for long-term
              success.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map((p, i) => {
            const accent = p.accent === "green" ? "#6B6B6B" : "#C9A66B";
            return (
              <article
                key={p.n}
                data-testid={`pillar-${p.title.toLowerCase()}`}
                className={`reveal p-8 md:p-10 ${
                  i !== PILLARS.length - 1
                    ? "border-b lg:border-b-0 lg:border-r border-[#2A2A2A]"
                    : ""
                } group transition-colors duration-500 hover:bg-[#141414]`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-baseline justify-between">
                  <span
                    className="font-serif text-5xl md:text-6xl font-light"
                    style={{ color: accent }}
                  >
                    {p.n}
                  </span>
                  <span className="text-[10px] tracking-[0.3em] uppercase text-[#A0A0A0]">
                    Pillar
                  </span>
                </div>
                <h3 className="font-serif text-3xl md:text-4xl text-[#EDEDED] font-light mt-10 tracking-tight">
                  {p.title}
                </h3>
                <div className="mt-4 w-8 h-px bg-[#EDEDED] group-hover:w-16 transition-all duration-500" />
                <p className="mt-6 text-[15px] leading-relaxed text-[#A0A0A0] font-light">
                  {p.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
